export interface DialogProps {
    status: boolean;
    onClose: () => void;
    children: any;
    title?: string;
    size?: DialogSize;
    closeButton?: boolean;
    closeOnBlur?: boolean;
    clearSelectedFiles?: boolean;
    className?: string;
    childrenParentClassName?: string;
    icon?: any;
    deleteDialog?: boolean;
    titleClssName?: string;
}

export enum DialogSize {
    SM = "md:max-w-lg",
    MD = "md:max-w-2xl",
    LG = "md:max-w-4xl",
    FULL = "w-full"
}
